import { useEffect, useState } from 'react';
import $ from 'jquery';

function useSlideDown(selector, condition) {
  const [animationOccured, setAnimationOccured] = useState(false);

  useEffect(() => {
    if (!animationOccured) {
      if (condition) {
        $(selector).slideDown('fast');
        setAnimationOccured(true);
      } else {
        $(selector).hide();
      }
    }
  }, [selector, condition, setAnimationOccured, animationOccured]);

  return animationOccured;
}

export default useSlideDown;
